/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'alpinejs'
import 'select2';

require('@coreui/coreui');

require('../bootstrap');
require('../plugins');
require('../utils');

require('./auth/signup');
require('./auth/passwords/reset');
require('./billing/subscribe');
require('./billing/extra-charge');
require('./onboarding/index');
require('./playground/index');
require('./api/index');

require('./fingerprint');